'use client';
import { AuthContainerV2 } from '../../v2';
import { AuthIterationType } from '../AuthIterations/types';
import styled from '@benzinga/themetron';
import ReactModal from 'react-modal';
const Modal = ReactModal as any;

export interface AuthModalProps extends AuthIterationType {
  isOpen: boolean;
  onRequestClose?: () => void;
}

const customStyles = {
  content: {
    background: 'transparent',
    border: 'none',
    bottom: 'auto',
    left: '50%',
    marginRight: '-50%',
    maxWidth: '500px',
    right: 'auto',
    top: '50%',
    //transform: 'translate(-50%, -50%)',
    width: '100%',
  },
  overlay: {
    background: 'rgba(51, 51, 51, 0.35)',
  },
};

export const AuthModal = ({ authMode = 'login', email, isOpen, onRequestClose }: AuthModalProps) => {
  const handleSuccess = () => {
    if (onRequestClose) {
      onRequestClose();
    }
  };
  return (
    <Modal contentLabel="Login Modal" isOpen={isOpen} onRequestClose={onRequestClose} style={customStyles}>
      <AuthContainerV2
        email={email}
        initialMode={authMode as 'login' | 'register'}
        onSuccess={handleSuccess}
        placement="auth-modal"
        redirectOnSuccess={false}
        surface="page"
      />
    </Modal>
  );
};

export const AuthModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: 520px;
  width: 100%;

  .register-action-container {
    margin-top: 2rem;
  }

  input {
    font-size: 16px;
  }

  .oauth-button-footer {
    display: flex;
    gap: 8px;
    @media (max-width: 500px) {
      flex-direction: column;
    }
  }

  .popup-container {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    padding: 40px;
    background: #ffffff;
    border-radius: 12px;
    border: 1px solid #e1ebfa;
    box-shadow: 0px 2px 8px 0px rgba(25, 68, 128, 0.05);

    @media (max-width: 768px) {
      padding: 20px;
      border: none;
      box-shadow: none;
    }

    @media (max-height: 800px) {
      padding: 12px 16px;
      border: none;
      box-shadow: none;
    }
  }
  .benzinga-logo {
    max-width: 150px;
  }
  .logo-wrapper {
    padding: 1rem;
  }
  .auth-action-title {
    font-weight: ${({ theme }) => theme.fontWeight.bold};
    font-size: ${({ theme }) => theme.fontSize.xl};
    text-align: center;
  }
`;
